<template>
    <div>
        <div style="border-spacing: 5px 5px">
            <el-checkbox-group v-if="listdata.length > 0" v-model="ids" style="margin-top: 15px" @change="checkboxChange">
                <div v-for="(photoSet, photoSetkey) in listdata" :key="photoSetkey" class="img-box">
                    <div class="inner-img">
                        <el-image v-if="photoSet.fileName.includes('.png') || photoSet.fileName.includes('.jpg') || photoSet.fileName.includes('.jpeg') || photoSet.fileName.includes('.gif')" class="out-img-box" :src="photoSet.downLoadUrl" :preview-src-list="[photoSet.downLoadUrl]" :append-to-body="true" @click="getUrl(photoSet.downLoadUrl)">
                            <div slot="error" class="image-slot">
                                <i class="el-icon-picture-outline" />
                            </div>
                        </el-image>
                        <el-image v-else class="out-img-box1" :src="photoSet.downLoadUrl" @click="onCellClick(photoSet)">
                            <div slot="error" class="image-slot">
                                <i class="el-icon-picture-outline" />
                            </div>
                        </el-image>
                    </div>
                    <div style="margin-top: 10px; font-size: 14px; cursor: pointer">
                        <span>{{ getName(photoSet.fileName) }}</span>
                    </div>
                </div>
            </el-checkbox-group>
            <div v-else>
                <Empty />
            </div>
        </div>
        <template v-if="showVideo">
            <el-dialog v-el-drag-dialog :title="videoTittle" :append-to-body="true" :visible.sync="showVideo" :width="'1000px'" :destroy-on-close="true" :close-on-click-modal="false">
                <videoDialog :width="'960px'" :height="'400px'" :video-url="videoUrl" :video-logo-url="videoImgUrl" />
            </el-dialog>
        </template>
    </div>
</template>

<script>
export default {
    props: {
        type: {
            type: String,
            default: function () {
                return ''
            }
        },
        cate: {
            type: String,
            default: function () {
                return ''
            }
        },
        searchKey: {
            type: String,
            default: function () {
                return ''
            }
        },
        isCheckAll: {
            type: Boolean,
            default: function () {
                return false
            }
        },
        isCheckStyle: {
            type: Boolean,
            default: function () {
                return false
            }
        },
        prefixFullName: {
            type: String,
            default: function () {
                return ''
            }
        },
        urlsearch: {
            type: String,
            default: function () {
                return ''
            }
        },
        treeNode: {
            type: Object,
            default: function () {
                return {}
            }
        }
    },
    data() {
        return {
            loginUser: this.$store.getters.loginUser,
            // treeNode: {},
            listdata: [],
            text: '',
            ids: [],
            base_api: '',
            photoUrlList: [],
            showVideo: false,
            videoTittle: '',
            videoImgUrl: '',
            videoUrl: '',
            downloadUrl: '/dagl/xmzlFile/downloadById',
            imageUrl: ''
        }
    },
    computed: {},
    watch: {
        // isCheckAll(val) {
        //     if (val) {
        //         const idArray = []
        //         if (this.cate === 'photoSet') {
        //             this.listdata.forEach(list => {
        //                 idArray.push(list.fileName)
        //             })
        //         } else {
        //             this.listdata.forEach(list => {
        //                 idArray.push(list.id)
        //             })
        //         }
        //         this.ids = idArray
        //     } else if (!val && !this.isCheckStyle) {
        //         this.ids = []
        //     }
        //     this.$nextTick(() => {
        //         this.$bus.emit('isCheckAllChange', this.ids, null, null)
        //     })
        // }
    },
    created() {
        this.$options.components['videoDialog'] = this.$loadComponent('@/wapp/common/components/Video/index')
        this.$options.components['Empty'] = this.$loadComponent('@/wapp/common/components/Empty/index')

        this.$bus.on('addPhotoSet', this.addPhotoSet)
        this.$bus.on('treeClick', this.treeClick)
        this.$bus.on('photoCateSearch', this.getPhotoSet)
        // this.getPhotoSetById()
        this.base_api = process.env.VUE_APP_BASE_API
    },
    beforeDestroy() {
        this.$bus.off('addPhotoSet', this.addPhotoSet)
        this.$bus.off('treeClick', this.treeClick)
        this.$bus.off('photoCateSearch', this.getPhotoSet)
    },
    mounted() {
        this.$nextTick(() => {
            document.addEventListener('click', (e) => {
                const viewer = document.querySelector('.el-image-viewer__wrapper')
                if (viewer && viewer.style.display !== 'none') {
                    // 检查是否已添加下载按钮
                    if (!document.querySelector('.el-image-viewer__download')) {
                        const downloadBtn = document.createElement('i')
                        downloadBtn.className = 'el-icon-download el-image-viewer__download'
                        downloadBtn.onclick = (event) => {
                            event.stopPropagation()
                            this.downloadImage(this.imageUrl)
                        }
                        document.querySelector('.el-image-viewer__actions').appendChild(downloadBtn)
                    }
                }
            })
        })
    },
    methods: {
        getUrl(url) {
            this.imageUrl = url
        },
        downloadImage(url) {
            const link = document.createElement('a')
            link.href = url
            link.download = ''
            link.click()
        },
        onCellClick(row) {
            // const api_url = window.location.protocol + '//' + window.location.hostname + ':' + window.location.port
            // let href = ''
            // if (row.name.split('.')[1] === 'pdf') {
            //     href = api_url + '/apigw/disk/file/download?id=' + row.id + '&inline=true&dataField=fileData&nameField=fileName&fileName=' + row.name
            // } else {
            //     href = api_url + '/apigw/disk/file/download?id=' + row.id + '&inline=true&toPdf=true&dataField=fileData&nameField=fileName&fileName=' + row.name
            // }

            // window.open('./plugins/PDFjs/web/viewer.html?file=' + encodeURIComponent(href))

            console.log(this.$vnode.context.$vnode.context.moduleClass, 'vwfilefolder', '文件管理', 'vwreaderfile', '分享给我', 'vwsharefile', '我分享的', 'vwcollectfile', '我收藏的')
            // 文件夹
            var id = ''
            var ids = ''
            var name = ''
            var type = row.flType
            id = row.id
            name = row.fileName
            ids = row.id
            this.id = id
            // 打开压缩包
            if (Number(type) === 4) {
                var list = JSON.parse(this.row.content)
                list.forEach((res) => {
                    // res.fileName = res.fileName.replaceAll('/', '-')
                    // res.fullId = res.fileName
                    res.id = res.fileId
                })

                this.treeData = this.treeDataAdapter(list)
                console.log(this.treeData)
                this.tableShow = true
                return
            }
            // 我收藏已过期的文件不让打开
            if (this.$vnode.context.$vnode.context.moduleClass === 'vwcollectfile' && Number(row.status) === 0) {
                return
            }
            if (Number(row.flType) === 2) {
                // 打开目录
                this.$bus.emit('setListDataUrl', id, row)
            } else {
                // 文件
                if (!row.id) return
                // window.open('./plugins/PDFjs/web/viewer.html?file=' +encodeURIComponent(window.location.protocol + '//' + window.location.host + process.env.VUE_APP_BASE_API + `${this.downloadUrl}?inline=true&attachIds=` + id + '&fileName=' + name))

                if (name.indexOf('.ofd') > -1) {
                    let downUrl = process.env.VUE_APP_BASE_API + this.downloadUrl + '?inline=true&attachIds=' + id + '&fileName=' + name + '&saveAs=' + name
                    window.open('./plugins/OfdJs/view.html?file=' + encodeURIComponent(downUrl))
                } else {
                    let onlineFile = ['.doc', '.docx', '.xls', '.xlsx', '.ppt', '.pptx']
                    let arr = name.split('.')
                    let nameType = '.' + arr[arr.length - 1]
                    if (onlineFile.includes(nameType)) {
                        window.open(process.env.VUE_APP_BASE_API + `${this.downloadUrl}?topdf=true&inline=true&attachIds=` + id + '&saveAs=' + name)
                    } else {
                        window.open(process.env.VUE_APP_BASE_API + `${this.downloadUrl}?inline=true&attachIds=` + id + '&saveAs=' + name)
                    }
                }
            }
        },
        downLoad(downLoadUrl) {
            const link = document.createElement('a')
            link.href = downLoadUrl
            link.download = ''
            link.click()
        },
        getName(name) {
            if (name.length > 15) {
                return name.substring(0, 8) + '...'
            } else {
                return name
            }
        },
        getSearch(val) {
            this.urlsearch = val
        },
        treeClick(treeNode) {
            this.treeNode = treeNode
            this.cate = 'photoCate'
            this.getPhotoSet()
        },
        // 查询图册
        // getPhotoSet(id) {
        //     const headHttp = {}
        //     if (this.type === 'photo') {
        //         if (this.cate === '' || (this.cate === 'photoCate' && this.cate !== 'photoSet')) {
        //             headHttp.method = 'POST'
        //             headHttp.url = 'portal/cms/pictureSet/querydata'
        //             headHttp.data = [{ 'compare': '=', 'field': 'deleteStatus', 'merge': true, 'value': 0 }, { 'compare': '=', 'field': 'orgCode', 'merge': true, 'value': this.loginUser.orgCode }]
        //             headHttp.params = { orderBy: 'orderNo asc' }
        //             if (this.cate === 'photoCate' && this.treeNode.id !== '0') {
        //                 headHttp.data.push({ 'compare': '=', 'field': 'cateId', 'merge': true, 'value': this.treeNode.id })
        //             }
        //             if (this.searchKey !== '') {
        //                 headHttp.data.push({ 'compare': 'like', 'field': 'name', 'merge': true, 'value': '%' + this.searchKey + '%' })
        //             }
        //         } else if (this.cate === 'photoSet') {
        //             headHttp.method = 'GET'
        //             headHttp.url = 'portal/cms/pictureSet/findPictureBySetId'
        //             headHttp.params = { pictureSetId: id }
        //         }
        //     } else if (this.type === 'video') {
        //         headHttp.method = 'POST'
        //         headHttp.url = 'portal/cms/video/querydata'
        //         headHttp.data = [{ 'compare': '=', 'field': 'deleteStatus', 'merge': true, 'value': 0 }, { 'compare': '=', 'field': 'orgCode', 'merge': true, 'value': this.loginUser.orgCode }]
        //         headHttp.params = { orderBy: 'createTime desc' }
        //         if (this.treeNode.id !== '0') {
        //             headHttp.data.push({ 'compare': '=', 'field': 'cateId', 'merge': true, 'value': this.treeNode.id })
        //         }
        //     }
        //     this.$http({
        //         method: headHttp.method,
        //         url: headHttp.url,
        //         contentType: 'application/x-www-form-urlencoded',
        //         data: headHttp.data || [],
        //         params: headHttp.params || {}
        //     }).then(res => {
        //         if (res.code === 'success') {
        //             const creartListdata = res.body.listdata || res.body.pictureList
        //             if (this.type === 'photo') {
        //                 if (this.cate === 'photoCate' || this.cate === '') {
        //                     creartListdata.forEach(list => {
        //                         list.downLoadUrl = this.base_api + '/portal/cms/pictureSet/download?dataField=logoData&nameField=logoName&id=' + list.id + '&httpPort=' + location.port
        //                     })
        //                 } else if (this.cate === 'photoSet') {
        //                     creartListdata.forEach(list => {
        //                         list.two = list.logoUrl
        //                         list.eight = list.pictureUrl
        //                         list.master = list.pictureUrl.replace('/eight/', '/master/')
        //                     })
        //                 }
        //             } else if (this.type === 'video') {
        //                 creartListdata.forEach(list => {
        //                     list.downLoadUrl = this.base_api + '/portal/cms/video/download?dataField=logoData&nameField=logoName&id=' + list.id + '&httpPort=' + location.port
        //                 })
        //             }
        //             this.listdata = creartListdata
        //             this.$nextTick(() => {
        //                 this.$bus.emit('setListData', creartListdata)
        //             })
        //         } else {
        //             this.$message.error(res.message)
        //         }
        //     })
        // },
        getPhotoSetById(name, search) {
            let params = {
                pageSize: 9999,
                pageNum: 1,
                orderBy: 'createDate desc',
                urlsearch: 'fullId like ' + this.treeNode.id + ';id!:' + this.treeNode.id
            }
            this.$http({
                method: 'POST',
                url: 'dagl/vwDaglFileFolder/listdata',
                contentType: 'application/x-www-form-urlencoded',
                params: params
            }).then((res) => {
                if (res.code === 'success') {
                    this.listdata = res.body.pageInfo.list
                    this.listdata.forEach((list) => {
                        if (list.fileName.includes('.png') || list.fileName.includes('.jpg') || list.fileName.includes('.jpeg') || list.fileName.includes('.gif')) {
                            list.downLoadUrl = this.base_api + '/dagl/xmzlFile/downloadById?inline=true&attachIds=' + list.id + '&saveAs=' + encodeURIComponent(list.fileName)
                        } else if (list.fileName.includes('.doc') || list.fileName.includes('.docx')) {
                            list.downLoadUrl = '/images/w-imgs/email/word.png'
                        } else if (!list.fileName.includes('.')) {
                            list.downLoadUrl = '/images/w-imgs/email/folder.png'
                        } else if (list.fileName.includes('.xlsx') || list.fileName.includes('.xls')) {
                            list.downLoadUrl = '/images/w-imgs/email/excel.png'
                        } else if (list.fileName.includes('.txt')) {
                            list.downLoadUrl = '/images/w-imgs/email/txt.png'
                        } else {
                            list.downLoadUrl = '/images/w-imgs/email/pdf.png'
                        }
                    })
                }
            })
        },
        // 多选
        checkboxChange(val) {
            const checkAll = this.ids.length === this.listdata.length
            const checkStyle = this.ids.length > 0 && this.ids.length < this.listdata.length
            this.$nextTick(() => {
                this.$bus.emit('isCheckAllChange', this.ids, checkAll, checkStyle)
            })
        },
        // 封面图点击事件
        coverClick(vo) {
            if (this.type === 'photo') {
                this.$nextTick(() => {
                    this.$bus.emit('coverClick', 'photoSet', vo)
                })
                this.$nextTick(() => {
                    this.$bus.emit('findSet', false)
                })
                this.cate = 'photoSet'
                this.getPhotoSet(vo.id)
            } else if (this.type === 'video') {
                this.$http({
                    method: 'GET',
                    contentType: 'application/x-www-form-urlencoded',
                    params: { id: vo.id },
                    url: 'portal/cms/video/getById'
                }).then((response) => {
                    if (response.code === 'success') {
                        const videovo = response.body.vo
                        this.videoTittle = videovo.name
                        this.videoUrl = videovo.passenger['url']
                        this.videoImgUrl = this.base_api + '/portal/cms/video/download?id=' + videovo.id + '&dataField=logoData&nameField=logoName&httpPort=' + location.port
                        this.showVideo = true
                    } else {
                        this.$message.error(response.message)
                    }
                })
            }
        },
        // 编辑
        editForm(vo) {
            let cate2 = ''
            if (this.type === 'photo' && (this.cate === '' || this.cate === 'photoCate')) {
                cate2 = 'photoSet'
            } else if (this.type === 'photo' && this.cate === 'photoSet') {
                cate2 = 'photo'
            } else if (this.type === 'video') {
                cate2 = 'video'
            }
            this.$nextTick(() => {
                this.$bus.emit('openPrivetForm', this.type, cate2, vo, 1, this.treeNode)
            })
        },
        // 删除
        deleteForm(id, logoname) {
            this.$nextTick(() => {
                this.$bus.emit('deleteResouse', false, id, logoname)
            })
        }
    }
}
</script>

<style scoped lang="scss">
.el-image-viewer__actions .el-image-viewer__download {
    position: absolute;
    right: 40px;
    top: 20px;
    color: #fff;
    cursor: pointer;
    font-size: 32px !important;
}

.el-image-viewer__actions .el-image-viewer__download:hover {
    color: #409eff;
}
.img-box {
    display: inline-block;
    text-align: center;
    vertical-align: middle;
    margin-right: 5px;
    margin-bottom: 10px;
    .inner-img {
        position: relative;
        height: 140px;
        width: 160px;
        max-width: 160px;
        background: #f5f7fa;
        //   display: table-cell;
        vertical-align: middle;
        border: 1px solid #dbdee2;
        cursor: pointer;
        overflow: hidden;
        .out-img-box {
            // object-fit: contain;
            //   //display: flex;
            //     /deep/ .el-image__inner{
            //         height: auto;
            //         align-self: center;
            //     }
            //     @media screen and (min-width:0\0)  {
            //         display: inline-block;
            //     }
            width: 100%;
            height: 100%;
            object-fit: contain; /* 等比缩放，完整显示图片，最大边贴合容器 */
            object-position: center;
            // background-color: #f5f5f5; /* 可选：留白区域背景色，避免空白突兀 */
            // border: 1px solid #eee; /* 可选：边框区分容器 */
        }
        .out-img-box1 {
            margin-top: 35px;
            width: 50%;
            height: 50%;
            object-fit: contain; /* 等比缩放，完整显示图片，最大边贴合容器 */
            object-position: center;
            // background-color: #f5f5f5; /* 可选：留白区域背景色，避免空白突兀 */
            // border: 1px solid #eee; /* 可选：边框区分容器 */
        }
        .inner-img-bac {
            position: absolute;
            top: 0;
            left: 0;
            background: #ffffff;
            width: 100%;
            height: 100%;
            z-index: 3;
            opacity: 0;
        }

        .operation {
            display: none;
            position: absolute;
            bottom: 0;
            padding: 3px;
            font-size: var(--portalFontSize13);
            width: 100%;
            z-index: 10;
            color: #ffffff;
        }
        .operation-bac {
            display: none;
            position: absolute;
            z-index: 5;
            width: 100%;
            bottom: 0;
            height: 25px;
            background: #000000;
            opacity: 0.4;
        }
        .s-oper {
            display: block;
        }
    }
    .inner-img:hover {
        .operation {
            display: block;
        }
        .operation-bac {
            display: block;
        }
    }
}
</style>
<style>
.el-image-viewer__actions .el-image-viewer__download {
    position: absolute;
    right: 10px;
    color: #fff;
    cursor: pointer;
    font-size: 24px;
}
.el-image-viewer__actions__inner {
    margin-left: -35px !important;
}
</style>
